export const animateCSS = (element, animation, remove, prefix = 'animate__') =>
  new Promise((resolve, reject) => {
    try {
      const node = document.querySelector(element);
      
      // Verificar si el nodo existe
      if (!node) {
        console.warn(`Element ${element} not found for animation`);
        resolve('Animation skipped - element not found');
        return;
      }

      const animationName = `${prefix}${animation}`;
      node.classList.add(`${prefix}animated`, animationName);
     
      function handleAnimationEnd(event) {
        event.stopPropagation();
        if(remove){
          node.classList.remove(`${prefix}animated`, animationName); 
        }
        resolve('Animation ended');
      }

      node.addEventListener('animationend', handleAnimationEnd, {once: true});
    } catch (error) {
      console.error("Animation error:", error);
      resolve('Animation error');
    }
  });

export const openModalVw = async (id, callback) => { 
  try {
    if (callback) callback();
    
    setTimeout(async () => {
      const modal = document.querySelector(id);
      if (!modal) {
        console.warn(`Modal ${id} not found for opening`);
        return;
      }
      
      modal.style.setProperty('opacity', '1');
      
      const content = document.querySelector(`${id} .modal-content`);
      if (content) {
        content.style.setProperty('--animate-duration', '.2s');
        content.style.setProperty('opacity', '1');
        await animateCSS(`${id} .modal-content`, "zoomIn", true);
      }
    }, 100);
  } catch (error) {
    console.error("Error opening modal:", error);
  }
};

export const closeModalVw = async (id, callback) => {
  try {
    const modal = document.querySelector(id);
    if (!modal) {
      console.warn(`Modal ${id} not found for closing`);
      if (callback) callback();
      return;
    }
    
    try {
      await animateCSS(`${id} .modal-content`, "zoomOut", false);
    } catch (animError) {
      console.warn("Animation error during modal close:", animError);
    }
    
    modal.style.setProperty('opacity', '0');
    
    if (callback) callback();
  } catch (error) {
    console.error("Error closing modal:", error);
    if (callback) callback();
  } 
};

export const openAlert = async (id, callback, closeIn, closeCb) => { 
  try {
    if (callback) callback();
    
    setTimeout(async () => {
      const modal = document.querySelector(id);
      if (!modal) {
        console.warn(`Alert ${id} not found for opening`);
        return;
      }
      
      modal.style.setProperty('opacity', '1');
      
      const content = document.querySelector(`${id}`);
      if (content) {
        content.style.setProperty('--animate-duration', '.7s');
        content.style.setProperty('opacity', '1');
        await animateCSS(`${id} .alert-actions`, "bounceIn", true);
      }

      if(closeIn){
        setTimeout(async () => {
          await closeAlert(id, closeCb);
        }, closeIn);
      }
    }, 100);
  } catch (error) {
    console.error("Error opening alert:", error);
  }
};

export const closeAlert = async (id, callback) => {
  try {
    const modal = document.querySelector(id);
    if (!modal) {
      console.warn(`Alert ${id} not found for closing`);
      if (callback) callback();
      return;
    }
    
    try {
      await animateCSS(`${id} .alert-actions`, "bounceOut", false);
    } catch (animError) {
      console.warn("Animation error during alert close:", animError);
    }
    
    modal.style.setProperty('opacity', '0');
    
    if (callback) callback();
  } catch (error) {
    console.error("Error closing alert:", error);
    if (callback) callback();
  }
};

export const safeCloseModalVw = (selector, callback) => {
  try {
    const elemento = document.querySelector(selector);
    if (!elemento) {
      console.warn(`Element ${selector} not found for safe closing`);
      if (callback && typeof callback === 'function') {
        callback();
      }
      return;
    }
    
    elemento.classList.add('closing');
    
    setTimeout(() => {
      if (callback && typeof callback === 'function') {
        callback();
      }
    }, 300);
  } catch (err) {
    console.error('Error al cerrar modal:', err);
    if (callback && typeof callback === 'function') {
      callback();
    }
  }
};